// Replaces the jquery.email.multiple plugin on the job pages. The original input
// is hidden and loses its name; each address becomes a readonly input with that
// name, so the form posts the same JobApplicationEmails values as before.
const emailPattern = /^[a-zA-Z0-9._-]+@[a-z0-9._-]+\.[a-z._-]+$/;

export function emailList(input, emails = []) {
  const name = input.getAttribute('name');
  input.removeAttribute('name');
  input.style.display = 'none'; // [hidden] loses to Bootstrap's .form-control { display: block }

  const wrapper = document.createElement('div');
  wrapper.className = 'email_multiple';
  wrapper.innerHTML = `
    <input type="email" class="enter-mail-id form-control" placeholder="Enter email…" aria-describedby="email-list-hint">
    <p id="email-list-hint" class="email_multiple-info mt-1 mb-0 text-xs text-slate-500">Press Enter to add each address.</p>
    <p class="email_multiple-error mt-1 mb-0 text-xs text-brand-accent" role="alert" hidden></p>
    <div class="all-mail mt-2 flex flex-wrap gap-2"></div>`;
  input.after(wrapper);

  const entry = wrapper.querySelector('.enter-mail-id');
  const error = wrapper.querySelector('.email_multiple-error');
  const list = wrapper.querySelector('.all-mail');

  const values = () => [...list.querySelectorAll('input')].map((chip) => chip.value.toLowerCase());

  const showError = (message) => {
    error.textContent = message || '';
    error.hidden = !message;
    entry.classList.toggle('input-validation-error', !!message);
  };

  const add = (value) => {
    const chip = document.createElement('span');
    chip.className = 'email-ids inline-flex items-center gap-1 rounded-full bg-slate-100 py-1 pr-1 pl-3 text-sm text-slate-700';
    chip.innerHTML = `
      <input type="text" readonly class="w-auto border-0 bg-transparent p-0 text-sm" size="1">
      <button type="button" class="cancel-email flex size-5 items-center justify-center rounded-full border-0 bg-transparent p-0 text-slate-500 hover:bg-slate-200 hover:text-slate-700">
        <span class="sr-only">Remove</span><svg class="size-3.5" aria-hidden="true"><use href="/dist/icons.svg#x-mark"></use></svg>
      </button>`;
    const chipInput = chip.querySelector('input');
    chipInput.name = name;
    chipInput.value = value;
    chipInput.size = Math.max(value.length, 1);
    chip.querySelector('button').addEventListener('click', () => chip.remove());
    list.append(chip);
  };

  entry.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    const value = entry.value.trim();

    if (!emailPattern.test(value)) {
      showError('Please enter a valid email address.');
    } else if (values().includes(value.toLowerCase())) {
      showError('That email address has already been added.');
    } else {
      add(value);
      entry.value = '';
      showError('');
    }
  });

  emails.filter((email) => emailPattern.test(email)).forEach(add);

  return {
    entry,
    count: () => list.children.length,
    reset() {
      list.replaceChildren();
      entry.value = '';
      showError('');
    },
  };
}
